import assetPath from '/opt/actions-runner/_work/crate/crate/xinglets/startpage-logged-out/entry/src/companies-section/assets/duerenhoff-photo.webp';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')